const initialState = null; // Initial state

const callerinsightReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CALLERINSIGHTS':
        return action.payload; // Set the session value
    
    default:
      return state;
  }
};

export default callerinsightReducer;
